/**
 * @generated SignedSource<<7feaf681fa06d965784cf2a1b8704b36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
export type QueriesInspectionListQuery$variables = {
  userId?: string | null;
};
export type QueriesInspectionListQuery$data = {
  readonly allInspectionfields: {
    readonly edgeCount: number | null;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly $updatableFragmentSpreads: FragmentRefs<"QueriesInspectionListUpdatable">;
        readonly assignedDate: any | null;
        readonly externalId: number | null;
        readonly field: {
          readonly geometry: any | null;
          readonly member: {
            readonly id: string;
            readonly name: string;
          } | null;
        } | null;
        readonly id: string;
        readonly latestInspection: {
          readonly approvedDate: any | null;
          readonly lastModified: any | null;
          readonly rejectedDate: any | null;
          readonly retryDate: any | null;
        } | null;
        readonly managementPackageVariant: {
          readonly code: string;
        } | null;
        readonly member: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly periodEnd: any | null;
        readonly periodStart: any | null;
        readonly plannedDate: any | null;
        readonly state: InspectionfieldStateEnum | null;
        readonly year: number;
        readonly " $fragmentSpreads": FragmentRefs<"InspectionFieldCard">;
      } | null;
    } | null>;
    readonly totalCount: number | null;
  } | null;
};
export type QueriesInspectionListQuery = {
  response: QueriesInspectionListQuery$data;
  variables: QueriesInspectionListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "inspector_Isnull",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "inspector_User",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edgeCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberNode",
  "kind": "LinkedField",
  "name": "member",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "geometry",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodEnd",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodStart",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastModified",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedDate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retryDate",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectedDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueriesInspectionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InspectionfieldNodeConnection",
        "kind": "LinkedField",
        "name": "allInspectionfields",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionfieldNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionfieldNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectNode",
                    "kind": "LinkedField",
                    "name": "managementPackageVariant",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FieldNode",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionNode",
                    "kind": "LinkedField",
                    "name": "latestInspection",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "InspectionFieldCard"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "QueriesInspectionListUpdatable"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueriesInspectionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InspectionfieldNodeConnection",
        "kind": "LinkedField",
        "name": "allInspectionfields",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionfieldNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionfieldNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectNode",
                    "kind": "LinkedField",
                    "name": "managementPackageVariant",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FieldNode",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previousId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionNode",
                    "kind": "LinkedField",
                    "name": "latestInspection",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ManagementPackageSettingsNode",
                    "kind": "LinkedField",
                    "name": "managementPackageSetting",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayNameAlt",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e71fc5a461a124f1c3ee31beb3a10837",
    "id": null,
    "metadata": {},
    "name": "QueriesInspectionListQuery",
    "operationKind": "query",
    "text": "query QueriesInspectionListQuery(\n  $userId: ID\n) {\n  allInspectionfields(inspector_Isnull: false, inspector_User: $userId) {\n    totalCount\n    edgeCount\n    edges {\n      node {\n        id\n        externalId\n        state\n        year\n        member {\n          id\n          name\n        }\n        managementPackageVariant {\n          code\n          id\n        }\n        field {\n          member {\n            id\n            name\n          }\n          geometry\n          id\n        }\n        periodEnd\n        periodStart\n        assignedDate\n        plannedDate\n        latestInspection {\n          lastModified\n          approvedDate\n          retryDate\n          rejectedDate\n          id\n        }\n        ...InspectionFieldCard\n        __typename\n      }\n    }\n  }\n}\n\nfragment InspectionFieldCard on InspectionfieldNode {\n  id\n  externalId\n  state\n  year\n  periodStart\n  periodEnd\n  assignedDate\n  plannedDate\n  latestInspection {\n    retryDate\n    approvedDate\n    rejectedDate\n    lastModified\n    id\n  }\n  managementPackageSetting {\n    displayNameAlt\n    id\n  }\n  member {\n    name\n    id\n  }\n  field {\n    id\n    previousId\n  }\n}\n"
  }
};
})();

(node as any).hash = "d9053f513fcbdc9b82adb6a14d8bb585";

export default node;
